export default __webpack_public_path__ + "media/images/brands/xpress/logos/logo-light-165x76-4da3c8d2ffd06aef4280da3a8662edc7.png";